













































































































































































































































































































































































import { SearchedCandidate } from "@/store/modules/recruiter/interfaces";
import Vue, { PropType } from "vue";
import { get_name_initials, format_overall_score } from "@/utils/global";
import DataNotFound from "@/components/shared/DataNotFound.vue";

export default Vue.extend({
  name: "CandidateDetailCard",
  components: {
    DataNotFound
  },
  data() {
    return {
      currentIndex: 0,
      startX: 0,
      endX: 0,
      selected: false,
      list_items: [
        {
          title: "View Candidate",
          action: "view"
        },
        {
          title: "View Screening Questions",
          action: "screening_questions"
        }
      ]
    };
  },
  props: {
    candidate_detail: {
      type: Object as PropType<SearchedCandidate>
    },
    show_blur: {
      type: Boolean,
      default: false
    },
    is_right: {
      type: Boolean,
      default: false
    },
    is_left: {
      type: Boolean,
      default: false
    },
    avatar_candidates: {
      type: Array as PropType<SearchedCandidate[]>
    },
    close_button_loading: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    shortlist_page: {
      type: Boolean,
      default: true
    },
    show_select_option: {
      type: Boolean,
      default: false
    },
    show_action_menu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    get_name(): string {
      if (
        this.candidate_detail.upload_response.profile?.personal_details?.name
          ?.first_name ||
        this.candidate_detail.upload_response.profile?.personal_details?.name
          ?.last_name
      )
        return (
          (this.candidate_detail.upload_response.profile?.personal_details?.name
            ?.first_name ?? " ") +
          " " +
          (this.candidate_detail.upload_response.profile?.personal_details?.name
            ?.last_name ?? " ")
        );
      return "Resume Details </br> Not Found";
    },
    candidate_name(): string {
      if (this.get_name === "Resume Details </br> Not Found") {
        return "Not Found";
      }
      return this.get_name;
    }
  },
  mounted() {
    this.selected = this.candidate_detail?.selected ? true : false;
  },
  watch: {
    candidate_detail: {
      handler() {
        this.selected = this.candidate_detail?.selected ? true : false;
      },
      deep: true
    }
  },
  methods: {
    get_name_initials,
    format_overall_score,
    get_work(): string {
      const profile = this.candidate_detail.upload_response.profile;
      if (
        profile &&
        profile.work_history_detailed &&
        Object.values(profile.work_history_detailed).length > 0
      )
        return Object.values(profile.work_history_detailed)[0].job_title;
      return "";
    },
    avatar_name(item: SearchedCandidate): string {
      return (
        (item.upload_response.profile?.personal_details?.name?.first_name ??
          " ") +
        " " +
        (item.upload_response.profile?.personal_details?.name?.last_name ?? "")
      );
    },
    transform_view_icon(icon: HTMLElement): HTMLElement {
      const color = "#00D2AA";
      for (let node of icon.children) node.setAttribute("stroke", color);
      return icon;
    },
    select() {
      this.selected = true;
      this.$emit("select");
    },
    unselect() {
      this.selected = false;
      this.$emit("unselect");
    },
    menu_list_change(item: { title: string; action: string }) {
      if (item.action === "view") this.$emit("view_profile");
      else if (item.action === "screening_questions")
        this.$emit("screening_questions");
    }
  }
});
